import React from 'react'
import './Modals/Modal.sass'

const Modal = props => {
    return (
        <div onClick={props.onClick}  style={props.styles} className='fade-in-fwd modal'>
            <div onClick={props.onOutsideClick} className="layer" style={{position: 'absolute',width: '100%', height: '100%'}} />
            {props.children}
        </div>
    )
}
export default Modal 